import ConsultingCaseListListResultModelBase from '../_generated/modelBases/consulting-case-list-list-result-model-base';

export default class ConsultingCaseListListResultModel extends ConsultingCaseListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
